import React, { useEffect, useRef } from "react";
import "./GameBuild.css";
import "../Gamecommon.css";

export default function GameBuild() {
  const bottomRef = useRef(null);

  useEffect(() => {
    const updateTimelineHeight = () => {
      const bottomEl = bottomRef.current;
      if (bottomEl) {
        const line = bottomEl.querySelector(".timeline-line");
        const leftCol = bottomEl.querySelector(".left");
        const rightCol = bottomEl.querySelector(".right");
        
        if (line && leftCol) {
          const isMobile = window.innerWidth <= 768;
          
          if (isMobile) {
            const leftHeight = leftCol.scrollHeight;
            const adjustedHeight = leftHeight - 40; 
            line.style.height = adjustedHeight + "px";
            
          line.style.bottom = "auto";
          } else {
       
            const leftHeight = leftCol.scrollHeight;
            const rightHeight = rightCol ? rightCol.scrollHeight + 150 : 0;
            const maxHeight = Math.max(leftHeight, rightHeight);
            line.style.height = maxHeight + "px";
            line.style.bottom = "auto";
          }
        }
      }
    };

    const timer = setTimeout(updateTimelineHeight, 100);

    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateTimelineHeight, 200);
    };
    
    window.addEventListener('resize', handleResize);
  
    window.addEventListener('orientationchange', handleResize);

    return () => {
      clearTimeout(timer);
      clearTimeout(resizeTimer);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

 return (
     <div id="gamebuild" className="gamemainclass">
        <span className="span-tag">NFT Game Development Services</span>
        <h2 className="h2-tag">Create Play-to-Earn Worlds with Innovative NFT Game Development</h2>
        <p className="p-tag">
         Bastionex offers NFT game development services to build secure, engaging games with play-to-earn mechanics and tokenized assets that captivate players.
        </p>
        <div className="bottom" ref={bottomRef}>
          <div className="timeline-line"></div>

          <div className="left">
            <div className="content">
              <span>Step 1</span>
              <h3>Custom NFT Game Design</h3>
              <p>
               Tailored gameplay mechanics with NFT integration, ensuring players can own, trade, and monetize in-game assets.
              </p>
            </div>
            <div className="content mobile-step-2">
              <span>Step 2</span>
              <h3>Blockchain & Smart Contract Integration</h3>
              <p>
               Secure tokenized assets with Ethereum, Polygon, or other blockchain protocols, enabling transparent transactions and verifiable ownership.
              </p>
            </div>
            <div className="content">
              <span>Step 3</span>
              <h3>Play-to-Earn (P2E) Mechanics</h3>
              <p>
               Reward players with in-game currency, NFTs, and tokens that hold real-world value, driving engagement and long-term retention.
              </p>
            </div>
            <div className="content mobile-step-4">
              <span>Step 4</span>
              <h3>Cross-Platform NFT Games</h3>
              <p>
               Build NFT-enabled games for web, mobile, and PC with seamless user experience and blockchain interoperability.
              </p>
            </div>
            <div className="content">
              <span>Step 5</span>
              <h3>Marketplace & Wallet Integration</h3>
              <p>
              Integrated NFT marketplaces and crypto wallets for buying, selling, and trading digital assets directly within the game ecosystem.
              </p>
            </div>
            <div className="content mobile-step-6">
              <span>Step 6</span>
              <h3>Token Economy Design</h3>
              <p>
               Create balanced in-game economies with NFT and token distribution strategies to maximize player engagement and long-term retention.
              </p>
            </div>
            <div className="content">
              <span>Step 7</span>
              <h3>Security & Compliance</h3>
              <p>
              Implement secure blockchain protocols and smart contracts with auditing to ensure player trust and regulatory compliance.
              </p>
            </div>
            {/* <div className="content mobile-step-8">
              <span>Step 8</span>
              <h3>Launch & Post-Release Support</h3>
              <p>
                We handle deployment, marketing support, and provide ongoing
                maintenance, updates, and feature enhancements to ensure long-term
                success.
              </p>
            </div> */}
          </div>

          <div className="right">
            <div className="content">
              <span>Step 2</span>
              <h3>Blockchain & Smart Contract Integration</h3>
              <p>
               Secure tokenized assets with Ethereum, Polygon, or other blockchain protocols, enabling transparent transactions and verifiable ownership.
              </p>
            </div>
            <div className="content">
              <span>Step 4</span>
              <h3>Cross-Platform NFT Games</h3>
              <p>
              Build NFT-enabled games for web, mobile, and PC with seamless user experience and blockchain interoperability.
              </p>
            </div>
            <div className="content">
              <span>Step 6</span>
              <h3>Token Economy Design</h3>
              <p>
             Create balanced in-game economies with NFT and token distribution strategies to maximize player engagement and long-term retention.
              </p>
            </div>
            {/* <div className="content">
              <span>Step 8</span>
              <h3>Security & Compliance</h3>
              <p>
              Implement secure blockchain protocols and smart contracts with auditing to ensure player trust and regulatory compliance.
              </p>
            </div> */}
          </div>
        </div>
      </div>
  );
}